import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class RepresentanteHierarquiaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar() {
    try {
      return await this.api.get('/representante-hierarquia');
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async listarGestores() {
    try {
      return await this.api.get('/representante-hierarquia/gestores');
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async definirGestor(representanteid, gestorid) {
    try {
      return await this.api.put(`/representante-hierarquia/${representanteid}/gestor`, { gestorid });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }
}
